import { schema } from 'normalizr';

const entitySchema = new schema.Entity('videoInstruction', undefined, { idAttribute: 'id' });

export default entitySchema;
